import current from "../routes/current"
import navigate from "../routes/navigate"
import { NAV_VIEW } from "../routes/urls"

export default el =>
  el.addEventListener("click", async e => {
    e.preventDefault()
    e.stopPropagation()

    if (current().name === NAV_VIEW) {
      return navigate()
    }

    const url = el.getAttribute("data-href") || el.getAttribute("href")

    return navigate(NAV_VIEW, url ? { url } : undefined)
  })
